module.exports = __webpack_public_path__ + "static/img/logo.3c4b03b0.png";